const config = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 50000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'lang': localStorage.getItem('lang') || 'en',
  },
  responseType: 'json',
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  validateStatus(status) {
    return status >= 200 && status < 300
  },
  maxRedirects: 5,
}

export default config
